import React from 'react'
import { Row, Col, Icon, Tooltip } from 'antd'
import PropTypes from 'prop-types'
import Highlighter from 'react-highlight-words';

//Model

// Components
import ViewTable from '../../../Table/ViewTable'
import Button from '../../../Buttons'
import RowTools from "../../../Table/RowTools";
import helper from "../../../../helper/helper";
import KQQTModal from "../Modal";
import message from "../../../Messages";
import typo, { MESSAGE } from '../../../../constants/dictionaries'
import CVModal from "../../../ConvertExcel/CV_QDXP"
import Api_quantrac from '../../../../api/api.quantrac'
import constants from '../../../../constants/constant'
import Input from "../../../Common/Input";
import Status from "../../../Table/Status/KetQuaQuanTrac"


export default class KetQuaQuanTrac extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      isAddModalOpen: false,
      isEditModalOpen: false,
      isCVModalOpen: false,
      miningQuantity: [],
      selectedRow: null,
      searchText: '',
      searchedColumn: '',
    }
  }
  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={typo.cscore_search}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
          mandatory={false}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          {typo.cscore_search}
        </Button>
        <Button type="primary" icon="reload" onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          {typo.cscore_lamMoi}
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Tooltip title="Lọc dữ liệu">
        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
      </Tooltip>
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
          text
        ),
  });
  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };
  handelOpenConvertExcel = () => {
    this.setState({
      isCVModalOpen: true
    })
  }
  handleCloseModalCV = (data, user) => {
    this.setState({
      isCVModalOpen: false,
    })
    if (data.length > 0) {
      new Api_quantrac().DeleteExcelKQQT_QDXP({ token: user.access_token, filename: data[0].fileName })
    }
  }
  handleAddCV = (item, file, user) => {
    const { dataSource, handleUpdate } = this.props;
    const newData = [...dataSource, ...item];
    if (file.length > 0) {
      new Api_quantrac().DeleteExcelKQQT_QDXP({ token: user.access_token, filename: file[0].fileName })
    }
    handleUpdate(newData);
  }

  handleOpenAddModal = () => {
    this.setState({
      isAddModalOpen: true
    })
  };

  handleOpenEditModal = (row) => {
    this.setState({
      selectedRow: row,
      isEditModalOpen: true
    })
  };

  handleShowDetail = (row) => {
    this.setState({
      selectedRow: row,
    })
  };

  handleCloseModal = () => {
    this.setState({
      isAddModalOpen: false,
      isEditModalOpen: false,
      selectedRow: null
    })
  };

  handleAdd = (item) => {
    const { dataSource, handleUpdate } = this.props;
    const newData = [{ ...item, daXoa: 0 }, ...dataSource];
    this.handleCloseModal();
    handleUpdate(newData);
  };

  handleEdit = (item) => {
    const { dataSource, handleUpdate, field } = this.props;
    const newData = helper.replaceItem(item, dataSource, "stt");
    this.handleCloseModal();
    handleUpdate(newData, field);
  };

  handleDelete = (item) => {
    const { dataSource, handleUpdate, field, isEdit } = this.props;
    const newData = helper.updateArray(item, dataSource, isEdit)
    handleUpdate(newData, field);
  };

  addSttToItems = (items) => {
    if (!items) return [];
    let newItems = [];
    if (items) {
      newItems = items.filter(item => item.daXoa === 0)
    }
    return newItems;
  };


  render() {
    const { isCVModalOpen, isAddModalOpen, isEditModalOpen, selectedRow } = this.state;
    const { dataSource, mode, idQuyetDinh, thietlapmau, view } = this.props;
    // Columns
    const columns_form = [
      {
        title: "#",
        dataIndex: "stt",
        width: "55px",
      },
      {
        title: "Thành phần môi trường",
        dataIndex: "tpmt_ma",
        width: "20%",
        render: (value, row) => (
          <div>{constants.THANH_PHAN_MOI_TRUONG_TEN[value]}</div>
        ),
      },
      {
        title: "Vị trí quan trắc",
        dataIndex: "tramquantrac_ten",
        width: "20%",
        key: "tramquantrac_ten",
        ...this.getColumnSearchProps('tramquantrac_ten')
      },
      {
        title: "Tên đợt quan trắc",
        dataIndex: "dotquantrac_ten",
        key: "dotquantrac_ten",
        ...this.getColumnSearchProps('dotquantrac_ten')
      },
      {
        title: "Đợt quan trắc số",
        dataIndex: "dotquantrac",
        key: "dotquantrac",
        ...this.getColumnSearchProps('dotquantrac')
      },
      {
        title: "Trạng thái",
        dataIndex: "ketqua_danhgia",
        width: 130,
        render: (value, row) => (
          <Tooltip title={row.thongso_vuotnguongs}>
            <div>
              <Status value={value} trangthai={value} />
            </div>
          </Tooltip>
        )
      },
      {
        title: "Thao tác",
        render: (value, row) => (
          <RowTools
            row={row}
            iconDelete={view === 'view' ? true : false}
            iconEdit={view === 'view' ? true : false}
            iconDetail={view === 'view' ? true : false}
            showDetail={() => this.handleOpenEditModal(row)}
            deleteRowModal={() => this.handleDelete(row)}
            showEditModal={() => this.handleOpenEditModal(row)}
          />
        ),
        width: "80px"
      },
    ];

    const columns = [
      {
        title: "#",
        dataIndex: "stt",
        width: "55px",
      },
      {
        title: "Thành phần môi trường",
        dataIndex: "tpmt_ma",
        width: "20%",
        render: (value, row) => (
          <div>{constants.THANH_PHAN_MOI_TRUONG_TEN[value]}</div>
        ),
      },
      {
        title: "Vị trí quan trắc",
        dataIndex: "tramquantrac_ten",
        width: "20%",
        key: "tramquantrac_ten",
        ...this.getColumnSearchProps('tramquantrac_ten')
      },
      {
        title: "Tên đợt quan trắc",
        dataIndex: "dotquantrac_ten",
        key: "dotquantrac_ten",
        ...this.getColumnSearchProps('dotquantrac_ten')
      },
      {
        title: "Đợt quan trắc số",
        dataIndex: "dotquantrac",
        key: "dotquantrac",
        ...this.getColumnSearchProps('dotquantrac')
      },
      {
        title: "Trạng thái",
        dataIndex: "ketqua_danhgia",
        width: 130,
        render: (value, row) => (
          <Tooltip title={row.thongso_vuotnguongs}>
            <div>
              <Status value={value} trangthai={value} />
            </div>
          </Tooltip>
        )
      },
    ];
    return (
      <Row>
        <Row type="flex" justify="end" align="middle">
          {view !== "view" &&
            <div>
              <Button type="excel" onClick={this.handelOpenConvertExcel}><Icon type="file-excel" />{typo.cscore_convertExcel}</Button>
              <Button type="primary" onClick={this.handleOpenAddModal} icon="plus" style={{ marginLeft: "10px" }} />
            </div>
          }
        </Row>
        <div className="mt-10" />
        <div style={{ maxHeight: "350px", overflowY: "auto" }}>
          <ViewTable
            bordered pagination={false}
            columns={mode !== "presentation" ? columns_form : columns}
            dataSource={this.addSttToItems(dataSource)}
          />
        </div>
        <span style={{ fontSize: "13px", color: "#000", fontWeight: "600" }}>Tổng số: {dataSource.length}</span>
        {isAddModalOpen &&
          <KQQTModal
            mode="add"
            isOpen={isAddModalOpen}
            handleCancel={this.handleCloseModal}
            handleOk={this.handleAdd}
            idQuyetDinh={idQuyetDinh}
            handleThietLap={this.props.thietlap}
            thietlapmau={thietlapmau}
          />}

        {isEditModalOpen &&
          <KQQTModal
            mode="edit"
            initialValues={selectedRow}
            isOpen={isEditModalOpen}
            handleCancel={this.handleCloseModal}
            handleOk={this.handleEdit}
            isEdit={true}
            idQuyetDinh={idQuyetDinh}
            handleThietLap={this.props.thietlap}
            thietlapmau={thietlapmau}
            view={view}
          />}
        {isCVModalOpen &&
          <CVModal
            isOpen={isCVModalOpen}
            handleCancel={this.handleCloseModalCV}
            handleAdd={this.handleAddCV}
            idQuyetDinh={idQuyetDinh}
          />}
      </Row>
    )
  }
}

KetQuaQuanTrac.propTypes = {
  // MODE: string "form" and "presentation"
  mode: PropTypes.string.isRequired,
  dataSource: PropTypes.array.isRequired,
  thietlap: PropTypes.func,
  handleUpdate: PropTypes.func,
};